<template>
    <div>
        <PlainTextField
            v-if="plainText"
            :title="title"
            clarity-class="clarity-mask"
            :model-value="email"
            :edit-style="editStyle"
        />
        <VeeField
            v-else
            v-slot="{value:fieldValue, handleChange, handleBlur, errors}"
            v-model="email"
            :name="name"
            :label="name"
            rules="required|email|max:50"
            :validate-on-mount="immediate"
            @blur="emailToASCII"
            @update:model-value="emailToASCII"
        >
            <div>
                <div
                    class="mt-[20px] md:mt-[30px] mb-[10px] font-medium"
                    :class="[
                        {'text-pink-800': !!errors[0]}, 
                        !memberStyle ? 'text-black' : ''
                    ]"
                >
                    {{ title }} 
                    <span
                        v-if="!memberStyle"
                        class="text-pink-800"
                    >*</span>
                </div>
                <div class="mt-2">
                    <FormTextField
                        :id="id"
                        :model-value="fieldValue"
                        :max-length="50"
                        :error="!!errors[0]"
                        :error-message="errors[0]"
                        :placeholder="placeholder"
                        :uppercase="false"
                        @keyup="handleBlur"
                        @update:model-value="handleChange"
                    />
                </div>
            </div>
        </VeeField>
    </div>
</template>

<script>
import FormTextField from '@/components/forms/TextField';
import PlainTextField from '@/components/forms/PlainTextField.vue';

export default{
    name: 'EmailField',
    components: { FormTextField, PlainTextField, },
    props: {
        // 編輯style開關
        editStyle: {
            type: Boolean,
            default: false
        },
        // 直接判定錯誤開關
        immediate: {
            type: Boolean,
            default: false
        },
        // 為純顯示非input
        plainText: {
            type: Boolean,
            default: true,
        },
        // 內容
        modelValue:{
            type: String,
            default: '', 
        },
        // input id
        id: {
            type: String,
            default: 'Email',
        },
        // 欄位名稱
        title: {
            type: String,
            default: '電子信箱'
        },
        // 檢核覽位名
        name: {
            type: String,
            default: '電子信箱'
        },
        // 會員資料style
        memberStyle: {
            type: Boolean,
            default: false,
        },
        // 未輸入時顯示的文字
        placeholder: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    data() {
        /** @param {String} email 電子信箱 */
        return {
            email: this.modelValue,
        };
    },
    methods:{
        /** 電子信箱 全形字符轉換半形字符 */
        emailToASCII(e) {
            if ((e && e.isComposing) || !this.email) return;
            this.email = this.$character.toASCII(this.email);
            this.$emit('update:modelValue', this.email);
        },
    }
};
</script>